"use strict";

var LoggerInstance = require("js-logger").get("SlideShowStore");

var AbstractStore = require("./AbstractStore");

var Constants = require("../designer/Constants");

var Dispatcher = require("../dispatcher/Dispatcher");

var state = {
	intervalId: null,
	isDesignMode: false,
	slideIndex: 0,
	touchstartX: 0,
	touchendX: 0
};

var SlideShowStore = class extends AbstractStore {
	constructor(dispatcher) {
		super();
		this.dispatchToken = dispatcher.register(action => {
			switch (action.actionType) {
				case Constants.SLIDESHOW_INITIALIZE:
					state.isDesignMode = action.isDesignMode;
					return true; // Don't emit change

				case Constants.SLIDESHOW_STARTED:
					state.slideIndex = action.slideIndex;
					if (state.intervalId >= 0) {
						clearInterval(state.intervalId);
					}
					state.intervalId = action.intervalId;
					return true;

				case Constants.SLIDESHOW_STOPPED:
					if (state.intervalId >= 0) {
						clearInterval(state.intervalId);
					}
					state.intervalId = null;
					return true;

				case Constants.SLIDESHOW_TOUCH_START:
					state.touchstartX = action.touchstartX;
					return true;

				case Constants.SLIDESHOW_TOUCH_END:
					state.touchendX = action.touchendX;
					return true;

				case Constants.SLIDESHOW_CHANGE_SLIDE:
					state.slideIndex = action.slideIndex;
					state.touchstartX = 0;
					state.touchendX = 0;
					break;

				default:
					// no op
					return true;
			}

			this.emitChange();
			return true;
		});
	}

	getState() {
		return state;
	}

	get(key) {
		return state[key];
	}
};

module.exports = new SlideShowStore(Dispatcher);
